import api from './api';
import { getJwt } from '@app/helpers';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

export interface CicloOrcamentario {
    id: string;
    nome: string;
    descricao: string;
    ano: number;
}

export interface CicloOrcamentarioHasJoinProjeto {
    nomeTipoProjetoPrevisao: string;
    id: string;
    nome: string;
    numero: string;
    codigo: string;
    areaId: number;
    departamentoId: number;
    diretoriaId: number;
    escopoAnual: string;
    nomeArea: string;
    nomeDepartamento: string;
    nomeDiretoria: string;
    id_Finplan: string;
}

export interface CicloOrcamentarioJoinProjeto {
    projetoId: string;
    cicloOrcamentarioId: string;
}

export const getAllCicloOrcamentario = () => api.get<CicloOrcamentario[]>(`ciclo`);

export const createCicloOrcamentario = (ciclo: CicloOrcamentario) => {
    return api.post<CicloOrcamentario>('ciclo', ciclo);
};

export const updateCicloOrcamentario = (ciclo: CicloOrcamentario) =>
    api.put<CicloOrcamentario>(`ciclo/${ciclo.id}`, ciclo);

export const updateCiclo = (ciclo: CicloOrcamentario) =>
    api
        .put<boolean>(`ciclo/${ciclo.id}`, ciclo)
        .then(result => true)
        .catch(err => false);

export const cicloOrcamentarioJoinProjeto = (join: CicloOrcamentarioJoinProjeto) => {
    return api.post<CicloOrcamentarioJoinProjeto>('ciclo/cicloOrcamentariojoinProjeto', join);
};

export const getAllcicloOrcamentarioHasJoinProjeto = (join: CicloOrcamentarioJoinProjeto) =>
    api.get<CicloOrcamentarioHasJoinProjeto[]>(`ciclo/cicloOrcamentarioHasJoinProjeto/${join.cicloOrcamentarioId}`);

export const deleteCicloOrcamentario = (id: string) => api.delete<CicloOrcamentario>(`ciclo/${id}`);

export const createPlanilhaTpa = (id: string, file: any, ciclo: CicloOrcamentario) => {
    const form = new FormData();

    form.append('file', file);
    form.append('id', id);
    form.append('descricao', ciclo.descricao);
    form.append('ano', ciclo.ano.toString());

    return api.post(`tap/createTap`, form, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};



export const exportaCicloOrcamentarioAno = (id: string) => {

    let urlBase = window.location.origin;
    trackPromise(Axios.get(urlBase + `/api/ciclo/exportarCicloOrcamentarioHasJoinProjeto/${id}`,
        {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "relatorioCicloOrcamentario.xlsx");
            link.setAttribute('id', 'relatorioCicloOrcamentarioId');
            document.body.appendChild(link);
            link.click();
            document.getElementById('relatorioCicloOrcamentarioId').outerHTML = '';
        }));
};